module.exports = require('./commonjs/cache').default


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/cache.js
// module id = 1664
// module chunks = 0